import styled from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
export const TagContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles.container)};
`;
//# sourceMappingURL=tag.styled.js.map